import React, { Component } from 'react';
import './scss/custom.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import plus from './icon/plus.svg';
import minus from './icon/minus.svg';
import ReactLoading from 'react-loading';
var DateDiff = require('date-diff');

var resArr = [];
var loadTime = '';
export class ServiceStatus extends Component {
    static displayName = ServiceStatus.name;

    constructor(props) {
        super(props);
        this.state = { status: [], expandedRows: [], expandedServiceRows: [], loading: true, updatedOn: '', datasetStatus: [] };

        fetch('api/SubmissionStatus/GetSubmissionStatuses?returnType=' + this.props.returnType)
            .then(response => response.json())
            .then(data => {
                this.setState({ status: data, loading: false, updatedOn: 'Updated now' });
            });
    }

    componentDidMount() {
        if (loadTime === '') {
            loadTime = new Date();
        }
        setInterval(
            () => this.loadData(),
            60000
        );

        setInterval(
            () => this.setElapsedTime(),
            10000
        );
    }

    loadData() {
        resArr = [];
        fetch('api/SubmissionStatus/GetSubmissionStatuses?returnType=' + this.props.returnType)
            .then(response => response.json())
            .then(data => {
                this.setState({ status: data, loading: false });
            });

        loadTime = new Date();
        this.setElapsedTime();
    }

    setElapsedTime() {
        var timeNow = new Date();
        if (loadTime !== '' && loadTime !== '0') {
            var timeDiff = new DateDiff(timeNow, loadTime);
            if (timeDiff.seconds() !== 0) {
                this.setState({ updatedOn: 'Last Updated ' + timeDiff.seconds() + ' seconds ago' });
            }
            else {
                this.setState({ updatedOn: 'Updated now' });
            }
        }
        else {
            loadTime = new Date();
            this.setState({ updatedOn: 'Updated now' });
        }
    }

    handleExpand = (status) => {
        let newExpandedRows = [...this.state.expandedRows];
        let idxFound = newExpandedRows.findIndex((id) => {
            return id === status.orgName;
        });

        if (idxFound > -1) {
            console.log("Collapsing " + status.orgName + " " + idxFound);
            newExpandedRows.splice(idxFound, 1);
        }
        else {
            console.log("Expanding " + status.orgName);
            newExpandedRows.push(status.orgName);
        }

        console.log("Expanded rows");
        console.log(newExpandedRows);

        this.setState({ expandedRows: [...newExpandedRows] });
    }

    isExpanded = (status) => {
        const idx = this.state.expandedRows.findIndex(
            (id) => {
                return id === status.orgName;
            }
        );

        return idx > -1;
    }

    handleServiceExpand = (status) => {
        let newExpandedRows = [...this.state.expandedServiceRows];
        let idxFound = newExpandedRows.findIndex((id) => {
            return id === status.group;
        });

        if (idxFound > -1) {
            console.log("Collapsing " + status.group + " " + idxFound);
            newExpandedRows.splice(idxFound, 1);
        }
        else {
            console.log("Expanding " + status.group);
            newExpandedRows.push(status.group);
        }

        console.log("Expanded rows");
        console.log(newExpandedRows);

        this.setState({ expandedServiceRows: [...newExpandedRows] });
    }

    isServiceExpanded = (status) => {
        const idx = this.state.expandedServiceRows.findIndex(
            (id) => {
                return id === status.group;
            }
        );

        return idx > -1;
    }

    getRows = (status) => {

        let rows = [];

        var color = '';

        if (status.status === 'Down') {
            color = "fa-rcircle"
        }
        else if (status.status === 'Unknown') {
            color = "fa-acircle"
        }
        else if (status.status === 'Available') {
            color = "fa-gcircle"
        }

        const firstRow = (
            <tr onClick={() => this.handleExpand(status)}>
                <td className="tdFont">{status.orgName}</td>
                <td><FontAwesomeIcon icon="circle" className={color} /></td>
                <td ><button>  {this.isExpanded(status) ? <img src={minus} className="iconButton" /> : <img src={plus} className="iconButton" />} </button></td>
            </tr>
        )

        rows.push(firstRow);

        if (this.isExpanded(status)) {
            const detailRow = (
                <tr>
                    <td className="tdFont tdAlign innerStatusTD">
                        Data Received at
                    </td>
                    <td className="tdFont innerStatusTD" colSpan="2">{status.rowKey}</td>
                </tr>
            );
            rows.push(detailRow);
        }

        return rows;
    }

    getServiceRows = (status) => {

        let rows = [];

        var color = '';
        if (status.data.filter(m => m.group === status.group && m.status === 'Down').length > 0) {
            color = "fa-rcircle"
        }
        else if (status.data.filter(m => m.group === status.group && m.status === 'Unknown').length > 0) {
            color = "fa-acircle"
        }
        else if (status.data.filter(m => m.group === status.group && m.status === 'Available').length > 0) {
            color = "fa-gcircle"
        }

        const firstRow = (
            <tr onClick={() => this.handleServiceExpand(status)}>
                <td className="tdFont">{status.group}</td>
                <td><FontAwesomeIcon icon="circle" className={color} /></td>
                <td ><button>  {this.isServiceExpanded(status) ? <img src={minus} className="iconButton" /> : <img src={plus} className="iconButton" />} </button></td>
            </tr>
        )

        rows.push(firstRow);

        if (this.isServiceExpanded(status)) {
            const detailRow = (
                status.data.filter(m => m.group === status.group).map(met => { return this.getNestedRows(met) })
            );
            rows.push(detailRow);
        }

        return rows;
    }
    getNestedRows = (status) => {
        let row = [];

        var color = '';

        if (status.status === 'Available') {
            color = "fa-gcircle"
        }
        else if (status.status === 'Unknown') {
            color = "fa-acircle"
        }
        else if (status.status === 'Down') {
            color = "fa-rcircle"
        }

        const detailRow = (<tr>
            <td className="tdFont tdAlign innerStatusTD">
                {status.rowKey}
            </td>
            <td className="tdFont innerStatusTD" colSpan="2">{(status.status === null) ? status.lastRefresh : <FontAwesomeIcon icon="circle" className={color} />}</td>
        </tr>)
        row.push(detailRow);
        return row;
    }

    // Dataset Status
    getDatasetStatusRows = (status) => {
        let rows = [];
        var color = '';

        if (status.outOfSync === 'Y') {
            color = "fa-rcircle"
        }
        else if (status.outOfSync === '') {
            color = "fa-acircle"
        }
        else if (status.outOfSync === 'N') {
            color = "fa-gcircle"
        }

        const firstRow = (
            <tr>
                <td className="tdFont">{status.rowKey}</td>
                <td className="tdHeaderAlign"><FontAwesomeIcon icon="circle" className={color} /></td>
                <td className="tdFont tdHeaderAlign">{status.dueDate}</td>
            </tr>
        )

        rows.push(firstRow);
        return rows;
    }

    renderStatusTable = (statuses) => {
        statuses.serviceStatus.filter(function (item) {
            var i = resArr.findIndex(x => x.group === item.group);
            if (i <= -1) {
                var groupedData = statuses.serviceStatus.filter(s => s.group === item.group);
                resArr.push({ group: item.group, status: item.status, data: groupedData });
            }
            return null;
        });

        const statusRows = statuses.submissionStatus.map((status) => {
            return this.getRows(status);
        });

        const serviceStatusRows = resArr.map((status) => {
            return this.getServiceRows(status);
        });

        const datasetStatusRows = statuses.datasetStatus.map((st) => {
            return this.getDatasetStatusRows(st)
        });

        let isDatasetRowsPresent = datasetStatusRows.length > 0;
        let status;

        if (statusRows.length > 0)
            status = true;
        else
            status = false;

        return (
            <div>
                <table className='submissionHeader'>
                    <tbody>
                        <tr>
                            <td className="tdFont innerStatusTD">
                                Products And Services
                    </td>
                            <td className="tdFont tdHeaderAlign innerStatusTD" colSpan="2">Status</td>
                        </tr>
                    </tbody>
                </table>
                <table className='table serviceStatus'>
                    <tbody>
                        {serviceStatusRows}
                    </tbody>
                </table>
                {status ? (<table className='submissionHeader'>
                    <tbody>
                        <tr>
                            <td className="tdFont innerStatusTD">
                                Trust Submission
                    </td>
                            <td className="tdFont tdHeaderAlign innerStatusTD" colSpan="2">Status</td>
                        </tr>
                    </tbody>
                </table>)
                    : null}
                <table className='table submissionStatus'>
                    <tbody>
                        {statusRows}
                    </tbody>
                </table>

                {isDatasetRowsPresent ? (<table className='submissionHeader'>
                    <tbody>
                        <tr>
                            <td className="tdFont innerStatusTD">
                                Dataset Name
                                </td>
                            <td className="tdFont tdHeaderAlign innerStatusTD">Status</td>
                            <td className="tdFont tdHeaderAlign innerStatusTD">Due Date</td>
                        </tr>
                    </tbody>
                </table>) : null}
                <table className='table submissionStatus'>
                    <tbody>
                        {datasetStatusRows}
                    </tbody>
                </table>
            </div>
        );
    }


    render() {
        let contents = this.state.loading
            ? <div><ReactLoading type={"spokes"} color={"#000"} height={'7%'} width={'7%'} className="loading-gif" /></div>
            : this.renderStatusTable(this.state.status);

        return (
            <div>
                <div className="btnrr"><span className="timeText">{this.state.updatedOn}</span></div>
                <div className="headerAlign">{this.props.displayName}</div>
                <div {...{ className: 'legend__align' }}>
                    <span>
                        <FontAwesomeIcon icon="circle" className="fa-gcircle" />
                        <span {...{ className: 'legend__font' }}> Good</span>
                    </span>
                    <span>
                        <FontAwesomeIcon icon="circle" className="fa-acircle" />
                        <span {...{ className: 'legend__font' }}> Degraded</span>
                    </span>
                    <span>
                        <FontAwesomeIcon icon="circle" className="fa-rcircle" />
                        <span {...{ className: 'legend__font' }}> Down</span>
                    </span>
                    <span>
                        <FontAwesomeIcon icon="info-circle" className="fa-icircle" />
                        <span {...{ className: 'legend__font' }}> Information</span>
                    </span>
                </div>
                {contents}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ServiceStatus.js